/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i.loading[_ngcontent-%COMP%]{color:grey}i.ok[_ngcontent-%COMP%]{color:green}i.error[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };
